import { useEffect, useMemo, useState } from "react";
import { IHeaderTable } from "types/global";

export const useDeliveryTripItemListPdfHeader = () => {
  const [headers, setHeaders] = useState<IHeaderTable[]>([]);
  const columns = useMemo<IHeaderTable[]>(
    () => [
      {
        thaiLabel: "",
        width: 16,
      },
      {
        thaiLabel: "รายการ",
        align: "left",
      },
      {
        thaiLabel: "จำนวน",
        width: 82.65,
        align: "right",
      },
      {
        thaiLabel: "จำนวนเงิน",
        width: 98.64,
        align: "right",
      },
    ],
    [],
  );
  useEffect(() => {
    setHeaders(columns);
  }, [columns]);

  return headers;
};
